import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-img-modal',
  templateUrl: './img-modal.component.html',
  styles: [],
})
export class ImgModalComponent implements OnInit {
  constructor(@Inject(MAT_DIALOG_DATA) public data: { src: string }) {}

  ngOnInit(): void {}
}
